<ng-container *transloco="let t">
  <div class="xi-modal__container account-change-timezone__container">
    <h2 class="xi-modal__title">{{ t('account-change-timezone.set-time-zone-label') }}</h2>

    <div class="timezone-picker xi-modal__content">
      <input
        #autoCompleteInput
        type="text"
        matInput
        required
        [matAutocomplete]="auto"
        [formControl]="pickerControl"
        [appAutoFocus]="autofocus"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn"
        [hideSingleSelectionIndicator]="true"
      >
        @for (option of filteredOptions | async; track option) {
          <mat-option
            [value]="option"
            [id]="option.id"
            [class.account-change__picker-option--selected]="option.id === timezone.id"
          >
            <div class="account-change-timezone__picker-option">
              <div>{{ option.label }}</div>
              @if (option.id === timezone.id) {
                <xi-icon
                  class="account-change__picker-option__selected-icon"
                  icon="circle_check_filled"
                  color="CX"
                ></xi-icon>
              }
            </div>
          </mat-option>
        }
      </mat-autocomplete>
    </div>

    <div class="account-change-timezone__actions xi-modal__actions">
      <xi-default-button
        text="{{ t('account-change-timezone.cancel-label') }}"
        fill="text"
        (onClick)="cancel()"
      ></xi-default-button>
      <xi-default-button
        [disabled]="pickerControl.invalid || timezoneInvalid"
        text="{{ t('account-change-timezone.set-time-zone-label') }}"
        (onClick)="confirm()"
      ></xi-default-button>
    </div>
  </div>
</ng-container>
